(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfterSlider {
    constructor(section) {
      this.viewer = section.querySelector('[data-ba-viewer]');
      this.wrap = this.viewer.querySelector('.ba-slider__image-wrap');
      this.before = section.querySelector('[data-ba-before]');
      this.handle = section.querySelector('[data-ba-handle]');
      this.hint = section.querySelector('[data-ba-hint]');
      this.isDragging = false;
      this.hasInteracted = false;

      this.bindEvents();
      this.animateEntry();
    }

    bindEvents() {
      var self = this;
      this.wrap.addEventListener('mousedown', function(e) { self.start(e); });
      window.addEventListener('mousemove', function(e) { self.move(e); });
      window.addEventListener('mouseup', function() { self.end(); });
      this.wrap.addEventListener('touchstart', function(e) { self.start(e); }, { passive: true });
      window.addEventListener('touchmove', function(e) { self.move(e); }, { passive: true });
      window.addEventListener('touchend', function() { self.end(); });
    }

    start(e) {
      this.isDragging = true;
      this.move(e);
      if (!this.hasInteracted) {
        this.hasInteracted = true;
        if (this.hint) this.hint.hidden = true;
      }
    }

    move(e) {
      if (!this.isDragging) return;
      var rect = this.wrap.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      var pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
      this.before.style.width = pct + '%';
      this.handle.style.left = pct + '%';
    }

    end() {
      this.isDragging = false;
    }

    animateEntry() {
      var self = this;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;

          var start = 50;
          var targets = [30, 70, 50];
          var durations = [600, 600, 400];
          var delay = 500;
          var current = 0;

          function animateTo(target, duration) {
            var from = start;
            var startTime = null;
            function step(ts) {
              if (!startTime) startTime = ts;
              var progress = Math.min((ts - startTime) / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              var val = from + (target - from) * eased;
              self.before.style.width = val + '%';
              self.handle.style.left = val + '%';
              if (progress < 1) {
                requestAnimationFrame(step);
              } else {
                start = target;
                current++;
                if (current < targets.length) {
                  setTimeout(function() {
                    animateTo(targets[current], durations[current]);
                  }, 100);
                }
              }
            }
            requestAnimationFrame(step);
          }

          setTimeout(function() {
            animateTo(targets[0], durations[0]);
          }, delay);

          observer.unobserve(entry.target);
        });
      }, { threshold: 0.3 });

      observer.observe(this.viewer);
    }
  }

  document.querySelectorAll('[data-ba-slider]').forEach(function(el) {
    new BeforeAfterSlider(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var tracks = document.querySelectorAll('[data-fbp-track]');
    tracks.forEach(function(track) {
      var carousel = track.closest('[data-fbp-carousel]');
      var isDragging = false;
      var startX = 0;
      var scrollLeft = 0;

      track.addEventListener('mousedown', function(e) {
        isDragging = true;
        startX = e.pageX;
        scrollLeft = carousel.scrollLeft;
      });
      track.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        e.preventDefault();
        carousel.scrollLeft = scrollLeft - (e.pageX - startX) * 1.2;
      });
      track.addEventListener('mouseup', function() { isDragging = false; });
      track.addEventListener('mouseleave', function() { isDragging = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-tires"] && !Shopify.designMode) return;
  try {
    
  // Apply season badge color classes based on text content
  document.querySelectorAll('.ft__card-season').forEach(function(el) {
    var text = (el.textContent || '').toLowerCase().replace(/[-\s]+/g, '');
    if (text.includes('winter'))               el.classList.add('ft__card-season--winter');
    else if (text.includes('allweather') || text.includes('all-weather')) el.classList.add('ft__card-season--allweather');
    else if (text.includes('summer'))          el.classList.add('ft__card-season--summer');
    else if (text.includes('allseason') || text.includes('all-season'))   el.classList.add('ft__card-season--allseason');
    else if (text.includes('terrain'))         el.classList.add('ft__card-season--allterrain');
  });

  document.querySelectorAll('[data-ft-section]').forEach(function(section) {
    var carousel = section.querySelector('[data-ft-carousel]');
    var track = section.querySelector('[data-ft-track]');
    var prevBtn = section.querySelector('[data-ft-prev]');
    var nextBtn = section.querySelector('[data-ft-next]');
    if (!carousel) return;

    var paused = false;

    /* ── Seamless infinite loop: clone all cards — desktop only ── */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.matchMedia('(max-width: 767px)').matches && track) {
      Array.from(track.children).forEach(function(card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      var halfWidth = 0;
      function computeHalf() { halfWidth = track.scrollWidth / 2; }
      computeHalf();
      window.addEventListener('resize', computeHalf);

      carousel.addEventListener('mouseenter', function() { paused = true; });
      carousel.addEventListener('mouseleave', function() { paused = false; });
      carousel.addEventListener('touchstart', function() { paused = true; }, { passive: true });
      carousel.addEventListener('touchend', function() {
        setTimeout(function() { paused = false; }, 900);
      });

      function tick() {
        if (!paused) {
          carousel.scrollLeft += 0.5;
          if (carousel.scrollLeft >= halfWidth) {
            carousel.scrollLeft -= halfWidth;
          }
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    /* ── Arrow buttons ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        paused = true;
        carousel.scrollBy({ left: -carousel.offsetWidth * 0.6, behavior: 'smooth' });
        setTimeout(function() { paused = false; }, 1000);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        paused = true;
        carousel.scrollBy({ left: carousel.offsetWidth * 0.6, behavior: 'smooth' });
        setTimeout(function() { paused = false; }, 1000);
      });
    }

    /* ── Mouse drag ── */
    var drag = { active: false, startX: 0, scrollLeft: 0 };
    carousel.addEventListener('mousedown', function(e) {
      drag.active = true;
      paused = true;
      drag.startX = e.pageX;
      drag.scrollLeft = carousel.scrollLeft;
      carousel.style.cursor = 'grabbing';
    });
    carousel.addEventListener('mousemove', function(e) {
      if (!drag.active) return;
      e.preventDefault();
      carousel.scrollLeft = drag.scrollLeft - (e.pageX - drag.startX);
    });
    carousel.addEventListener('mouseup', function() { drag.active = false; paused = false; carousel.style.cursor = ''; });
    carousel.addEventListener('mouseleave', function() { drag.active = false; carousel.style.cursor = ''; });

    /* ── Touch swipe ── */
    carousel.addEventListener('touchstart', function(e) {
      drag.active = true;
      drag.startX = e.touches[0].pageX;
      drag.scrollLeft = carousel.scrollLeft;
    }, { passive: true });
    carousel.addEventListener('touchmove', function(e) {
      if (!drag.active) return;
      carousel.scrollLeft = drag.scrollLeft - (e.touches[0].pageX - drag.startX);
    }, { passive: true });
    carousel.addEventListener('touchend', function() {
      drag.active = false;
      setTimeout(function() { paused = false; }, 900);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function() {
    var bar = document.querySelector('[data-pt-progress-bar]');
    var article = document.querySelector('[data-pt-article]');
    if (!bar || !article) return;

    function updateProgress() {
      var rect = article.getBoundingClientRect();
      var articleTop = rect.top + window.scrollY;
      var articleHeight = article.offsetHeight;
      var viewportHeight = window.innerHeight;
      var scrollY = window.scrollY;

      var start = articleTop;
      var end = articleTop + articleHeight - viewportHeight;
      var progress = 0;

      if (scrollY >= start && end > start) {
        progress = ((scrollY - start) / (end - start)) * 100;
        if (progress > 100) progress = 100;
        if (progress < 0) progress = 0;
      } else if (scrollY >= end) {
        progress = 100;
      }

      bar.style.width = progress + '%';
    }

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          updateProgress();
          ticking = false;
        });
        ticking = true;
      }
    });

    updateProgress();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function() {
    function initAuthPage() {
    var section = document.querySelector('.auth-page');
    if (!section) return;

    // Mark body so the auth-only stylesheet rules (hide theme header/footer) apply
    document.body.classList.add('auth-page-body');

    // Password visibility toggle
    section.querySelectorAll('[data-toggle-password]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.closest('.auth-page__input-wrap').querySelector('input');
        var eyeOpen = this.querySelector('.auth-page__eye-open');
        var eyeClosed = this.querySelector('.auth-page__eye-closed');
        if (input.type === 'password') {
          input.type = 'text';
          eyeOpen.style.display = 'none';
          eyeClosed.style.display = 'block';
        } else {
          input.type = 'password';
          eyeOpen.style.display = 'block';
          eyeClosed.style.display = 'none';
        }
        input.focus();
      });
    });

    // Toggle between login and recover — with auto-fill email
    var loginForm = document.getElementById('login-form');
    var recoverForm = document.getElementById('recover-form');
    section.querySelectorAll('[data-toggle-recover]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (loginForm.style.display === 'none') {
          recoverForm.style.display = 'none';
          loginForm.style.display = 'block';
        } else {
          loginForm.style.display = 'none';
          recoverForm.style.display = 'block';
          // Auto-fill email from login field into recover field
          var loginEmail = document.getElementById('CustomerEmail');
          var recoverEmail = document.getElementById('RecoverEmail');
          if (loginEmail && recoverEmail && loginEmail.value) {
            recoverEmail.value = loginEmail.value;
          }
          if (recoverEmail) recoverEmail.focus();
        }
      });
    });

    if (window.location.hash === '#recover') {
      loginForm.style.display = 'none';
      recoverForm.style.display = 'block';
    }

    // ── Account type toggle (Customer ↔ Shop) ──
    var toggleCustomer = document.getElementById('AuthTypeCustomer');
    var toggleShop     = document.getElementById('AuthTypeShop');
    var returnToInput  = document.getElementById('AuthReturnTo');
    var titleEl        = document.getElementById('AuthTitle');
    var subtitleEl     = document.getElementById('AuthSubtitle');
    var btnTextEl      = document.getElementById('AuthBtnText');
    var btnIconEl      = document.getElementById('AuthBtnIcon');
    var iconCustomer   = document.getElementById('AuthIconCustomer');
    var iconShop       = document.getElementById('AuthIconShop');
    var registerLink   = document.getElementById('AuthRegisterLink');
    var shopNote       = document.getElementById('AuthShopRegisterNote');
    var authSwitchRow  = registerLink ? registerLink.closest('.auth-page__switch') : null;
    var brandHeadline  = document.getElementById('AuthBrandHeadline');
    var brandDesc      = document.getElementById('AuthBrandDesc');

    var shopIconSVGPaths = '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><line x1="9" y1="22" x2="9" y2="12"/><line x1="15" y1="22" x2="15" y2="12"/><line x1="3" y1="13" x2="21" y2="13"/>';
    var garageIconSVGPaths = '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/>';

    function setMode(mode) {
      var isShop = mode === 'shop';

      // Toggle button active state
      toggleCustomer.classList.toggle('auth-type-toggle__btn--active', !isShop);
      toggleShop.classList.toggle('auth-type-toggle__btn--active', isShop);

      // Visual mode class on root
      section.classList.toggle('auth-page--shop-mode', isShop);

      // return_to destination
      if (returnToInput) returnToInput.value = isShop ? '/pages/wholesale-portal' : '/account';

      // Badge icon
      if (iconCustomer) iconCustomer.style.display = isShop ? 'none' : 'block';
      if (iconShop)     iconShop.style.display     = isShop ? 'block' : 'none';

      // Heading (right panel)
      if (titleEl)    titleEl.textContent    = isShop ? 'Dealer sign in' : 'Welcome back';
      if (subtitleEl) subtitleEl.textContent = isShop
        ? 'Trade pricing, fleet orders, and your dealer dashboard.'
        : 'Sign in to your garage and manage your vehicles & orders.';

      // Left-panel brand headline + tagline (mode-aware via data-* attributes)
      if (brandHeadline) {
        var hk = isShop ? brandHeadline.getAttribute('data-headline-shop') : brandHeadline.getAttribute('data-headline-customer');
        if (hk) brandHeadline.textContent = hk;
      }
      if (brandDesc) {
        var tk = isShop ? brandDesc.getAttribute('data-tagline-shop') : brandDesc.getAttribute('data-tagline-customer');
        if (tk) brandDesc.textContent = tk;
      }

      // Button icon & label
      if (btnIconEl) btnIconEl.innerHTML = isShop ? shopIconSVGPaths : garageIconSVGPaths;
      if (btnTextEl) btnTextEl.textContent = isShop ? 'Enter dealer portal' : 'Enter my garage';

      // Register link row
      if (authSwitchRow) authSwitchRow.style.display = isShop ? 'none' : '';
      if (shopNote)      shopNote.style.display      = isShop ? 'block' : 'none';
    }

    if (toggleCustomer) toggleCustomer.addEventListener('click', function() { setMode('customer'); });
    if (toggleShop)     toggleShop.addEventListener('click',     function() { setMode('shop'); });

    // Initialise — if URL has ?type=shop, pre-select shop tab
    if (window.location.search.indexOf('type=shop') !== -1) {
      setMode('shop');
    }

    // Submit button loading state
    section.querySelectorAll('form').forEach(function(form) {
      form.addEventListener('submit', function() {
        var btn = form.querySelector('[data-submit-btn]');
        if (!btn) return;
        var inner = btn.querySelector('.auth-page__btn-inner');
        var spinner = btn.querySelector('.auth-page__btn-spinner');
        btn.disabled = true;
        btn.classList.add('auth-page__btn--loading');
        if (inner) inner.style.display = 'none';
        if (spinner) spinner.style.display = 'flex';
      });
    });
    } // end initAuthPage
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAuthPage);
    } else {
      initAuthPage();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.auth-page');
    if (!section) return;

    // Password visibility toggle
    section.querySelectorAll('[data-toggle-password]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.closest('.auth-page__input-wrap').querySelector('input');
        var eyeOpen = this.querySelector('.auth-page__eye-open');
        var eyeClosed = this.querySelector('.auth-page__eye-closed');
        if (input.type === 'password') {
          input.type = 'text';
          eyeOpen.style.display = 'none';
          eyeClosed.style.display = 'block';
        } else {
          input.type = 'password';
          eyeOpen.style.display = 'block';
          eyeClosed.style.display = 'none';
        }
        input.focus();
      });
    });

    // Password strength meter with translated labels
    var pwInput = document.getElementById('RegisterForm-password');
    var strengthWrap = section.querySelector('[data-pw-strength]');
    var strengthBar = section.querySelector('[data-pw-bar]');
    var strengthLabel = section.querySelector('[data-pw-label]');

    if (pwInput && strengthWrap && strengthBar && strengthLabel) {
      var levels = [
        { width: '20%', color: '#ef4444', label: strengthWrap.dataset.weak },
        { width: '40%', color: '#f97316', label: strengthWrap.dataset.fair },
        { width: '60%', color: '#eab308', label: strengthWrap.dataset.good },
        { width: '80%', color: '#22c55e', label: strengthWrap.dataset.strong },
        { width: '100%', color: '#16a34a', label: strengthWrap.dataset.veryStrong }
      ];

      pwInput.addEventListener('input', function() {
        var val = this.value;
        if (val.length === 0) {
          strengthWrap.style.display = 'none';
          return;
        }
        strengthWrap.style.display = 'flex';

        var score = 0;
        if (val.length >= 5) score++;
        if (val.length >= 8) score++;
        if (/[A-Z]/.test(val)) score++;
        if (/[0-9]/.test(val)) score++;
        if (/[^A-Za-z0-9]/.test(val)) score++;

        var level = levels[Math.min(score, 4)];
        strengthBar.style.width = level.width;
        strengthBar.style.backgroundColor = level.color;
        strengthLabel.textContent = level.label;
        strengthLabel.style.color = level.color;
      });
    }

    // ── Account type toggle (Customer ↔ Shop) ──
    var regToggleCustomer = document.getElementById('RegTypeCustomer');
    var regToggleShop     = document.getElementById('RegTypeShop');
    var regCustomerPanel  = document.getElementById('RegCustomerPanel');
    var regShopPanel      = document.getElementById('RegShopPanel');

    function setRegMode(mode) {
      var isShop = mode === 'shop';
      if (regToggleCustomer) regToggleCustomer.classList.toggle('auth-type-toggle__btn--active', !isShop);
      if (regToggleShop)     regToggleShop.classList.toggle('auth-type-toggle__btn--active', isShop);
      if (regCustomerPanel)  regCustomerPanel.style.display = isShop ? 'none' : 'block';
      if (regShopPanel)      regShopPanel.style.display      = isShop ? 'block' : 'none';
    }

    if (regToggleCustomer) regToggleCustomer.addEventListener('click', function() { setRegMode('customer'); });
    if (regToggleShop)     regToggleShop.addEventListener('click',     function() { setRegMode('shop'); });

    // Pre-select shop tab if ?type=shop
    if (window.location.search.indexOf('type=shop') !== -1) {
      setRegMode('shop');
    }

    // Submit button loading state + required consent gate
    section.querySelectorAll('form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        // Gate on required consent checkbox (Terms + Privacy)
        var consent = form.querySelector('[data-required-consent]');
        if (consent && !consent.checked) {
          e.preventDefault();
          var label = consent.closest('.auth-page__checkbox-label');
          if (label) label.classList.add('auth-page__checkbox-label--invalid');
          consent.focus();
          return;
        }

        var btn = form.querySelector('[data-submit-btn]');
        if (!btn) return;
        var inner = btn.querySelector('.auth-page__btn-inner');
        var spinner = btn.querySelector('.auth-page__btn-spinner');
        btn.disabled = true;
        btn.classList.add('auth-page__btn--loading');
        if (inner) inner.style.display = 'none';
        if (spinner) spinner.style.display = 'flex';
      });
    });

    // Clear invalid state on consent check
    section.querySelectorAll('[data-required-consent]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var label = this.closest('.auth-page__checkbox-label');
        if (label && this.checked) label.classList.remove('auth-page__checkbox-label--invalid');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
  (function() {
    /* Load more */
    var loadBtn = document.querySelector('[data-pr-load-more]');
    if (loadBtn) {
      loadBtn.addEventListener('click', function() {
        document.querySelectorAll('.product-reviews__item--hidden').forEach(function(el) {
          el.classList.remove('product-reviews__item--hidden');
        });
        loadBtn.parentElement.style.display = 'none';
      });
    }

    /* Star rating select */
    var starBtns = document.querySelectorAll('[data-pr-star]');
    var selectedRating = 0;
    starBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectedRating = parseInt(this.dataset.prStar);
        starBtns.forEach(function(b) {
          b.classList.toggle('product-reviews__star-btn--active', parseInt(b.dataset.prStar) <= selectedRating);
        });
      });
      btn.addEventListener('mouseenter', function() {
        var hover = parseInt(this.dataset.prStar);
        starBtns.forEach(function(b) {
          b.classList.toggle('product-reviews__star-btn--active', parseInt(b.dataset.prStar) <= hover);
        });
      });
    });
    var starsWrap = document.querySelector('[data-pr-stars]');
    if (starsWrap) {
      starsWrap.addEventListener('mouseleave', function() {
        starBtns.forEach(function(b) {
          b.classList.toggle('product-reviews__star-btn--active', parseInt(b.dataset.prStar) <= selectedRating);
        });
      });
    }

    /* Submit review (localStorage) */
    var submitBtn = document.querySelector('[data-pr-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function() {
        var name = document.querySelector('[data-pr-name]').value.trim();
        var title = document.querySelector('[data-pr-title]').value.trim();
        var body = document.querySelector('[data-pr-body]').value.trim();
        if (!name || !body || selectedRating === 0) { alert('Please fill in your name, select a rating, and write a review.'); return; }
        var reviews = JSON.parse(localStorage.getItem('pt_reviews') || '[]');
        reviews.push({ name: name, rating: selectedRating, title: title, body: body, product: window.location.pathname, date: new Date().toISOString().split('T')[0] });
        localStorage.setItem('pt_reviews', JSON.stringify(reviews));
        document.querySelector('[data-pr-form]').style.display = 'none';
        document.querySelector('[data-pr-success]').hidden = false;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-brand-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Scroll-reveal
    var els = document.querySelectorAll('.ptbd [data-reveal]');
    if (els.length && typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
    }

    // Carousel: tab filtering + arrow scrolling
    var carousel = document.querySelector('.ptbd__carousel');
    if (!carousel) return;
    var cards = carousel.querySelectorAll('.ptbd__card');
    var tabs = document.querySelectorAll('.ptbd__tab');
    var arrows = document.querySelectorAll('.ptbd__carousel-arrow');

    function setArrowState() {
      var prev = document.querySelector('.ptbd__carousel-arrow--prev');
      var next = document.querySelector('.ptbd__carousel-arrow--next');
      if (!prev || !next) return;
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;
      prev.disabled = carousel.scrollLeft <= 2;
      next.disabled = carousel.scrollLeft >= maxScroll - 2;
    }
    carousel.addEventListener('scroll', setArrowState, { passive: true });
    window.addEventListener('resize', setArrowState);

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.dataset.dir, 10) || 1;
        var card = carousel.querySelector('.ptbd__card:not(.is-filtered-out)');
        var step = card ? card.getBoundingClientRect().width + 16 : 320;
        carousel.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = tab.dataset.filter;
        tabs.forEach(function (t) {
          var on = (t === tab);
          t.classList.toggle('ptbd__tab--active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        cards.forEach(function (c) {
          var match = (filter === 'all' || c.dataset.season === filter);
          c.classList.toggle('is-filtered-out', !match);
        });
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(setArrowState, 300);
      });
    });

    setArrowState();

    // Hash-driven smooth-scroll to a specific model card (e.g. /pages/brand-michelin#crossclimate2)
    function scrollToHashCard() {
      var hash = (location.hash || '').replace(/^#/, '');
      if (!hash) return;
      var target = document.getElementById(hash);
      if (!target || !target.classList.contains('ptbd__card')) return;
      // If filtered out by an active season tab, reset to "All" so the card is visible
      if (target.classList.contains('is-filtered-out')) {
        var allTab = document.querySelector('.ptbd__tab[data-filter="all"]');
        if (allTab) allTab.click();
      }
      setTimeout(function () {
        // Carousel is a horizontally-scrolling container — scroll inside it
        var rect = target.getBoundingClientRect();
        var crect = carousel.getBoundingClientRect();
        carousel.scrollBy({ left: rect.left - crect.left - 24, behavior: 'smooth' });
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.classList.add('ptbd__card--highlight');
        setTimeout(function () { target.classList.remove('ptbd__card--highlight'); }, 1800);
      }, 120);
    }
    scrollToHashCard();
    window.addEventListener('hashchange', scrollToHashCard);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-brands-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Scroll-reveal
    var els = document.querySelectorAll('.ptbg [data-reveal]');
    if (els.length && typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
    }

    // Per-tier brand tabs filter the tier's product carousel.
    // Brand tabs are also clickable as nav links (data-href) if held by ctrl/cmd,
    // but a plain click just filters. We add a separate "View brand →" affordance.
    document.querySelectorAll('.ptbg__tier').forEach(function (tierEl) {
      var tabs = tierEl.querySelectorAll('.ptbg__brand-tab');
      var carousel = tierEl.querySelector('.ptbg__products');
      var prev = tierEl.querySelector('[data-tier-prev]');
      var next = tierEl.querySelector('[data-tier-next]');
      if (!carousel) return;
      var products = carousel.querySelectorAll('.ptbg__product');

      function setArrowState() {
        if (!prev || !next) return;
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        prev.disabled = carousel.scrollLeft <= 2;
        next.disabled = carousel.scrollLeft >= maxScroll - 2;
      }
      carousel.addEventListener('scroll', setArrowState, { passive: true });
      if (prev) prev.addEventListener('click', function () {
        var step = (carousel.querySelector('.ptbg__product:not(.is-filtered-out)') || {}).offsetWidth || 240;
        carousel.scrollBy({ left: -(step + 16), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        var step = (carousel.querySelector('.ptbg__product:not(.is-filtered-out)') || {}).offsetWidth || 240;
        carousel.scrollBy({ left: step + 16, behavior: 'smooth' });
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          // Cmd/Ctrl-click on a brand tab: open the brand page directly.
          if ((e.metaKey || e.ctrlKey) && tab.dataset.href) {
            window.open(tab.dataset.href, '_blank');
            return;
          }
          // Double-click: go to the brand page.
          // (single click just filters)
          var brand = tab.dataset.brand;
          tabs.forEach(function (t) {
            var on = (t === tab);
            t.classList.toggle('ptbg__brand-tab--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          products.forEach(function (p) {
            var match = (brand === 'all' || p.dataset.brand === brand);
            p.classList.toggle('is-filtered-out', !match);
          });
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
          setTimeout(setArrowState, 350);
        });
        // Double-click on a brand tab: navigate to the brand's dedicated page.
        tab.addEventListener('dblclick', function () {
          if (tab.dataset.href) window.location.href = tab.dataset.href;
        });
      });
      setArrowState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-header"]) return;
  try {
    
  /* Scroll-pill effect — toggles .is-scrolled on the header past 4px */
  (function() {
    var hdr = document.querySelector('[data-pt-header]');
    if (!hdr) return;
    function syncScroll() {
      hdr.classList.toggle('is-scrolled', window.scrollY > 4);
    }
    syncScroll();
    window.addEventListener('scroll', syncScroll, { passive: true });
  })();

  /* Garage badge */
  (function() {
    var badge = document.querySelector('[data-garage-count]');
    if (!badge) return;

    function updateBadge(count) {
      if (count > 0) {
        badge.textContent = count;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    /* Read initial count from localStorage */
    var garageLink = document.querySelector('[data-garage-customer-id]');
    var customerId = garageLink ? garageLink.dataset.garageCustomerId : null;
    if (customerId) {
      try {
        var raw = localStorage.getItem('pt-garage-' + customerId);
        var vehicles = raw ? JSON.parse(raw) : [];
        updateBadge(vehicles.length);
      } catch(e) {}
    }

    /* Subscribe to live updates */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.garageUpdate, function(data) {
        updateBadge(data.vehicles ? data.vehicles.length : 0);
      });
    }
  })();

  /* ── Phase 5A · trade-price toggle ───────────────────────────────────── */
  /*
   * Default OFF: theme displays RETAIL on every [data-pt-price] element so a
   * B2B shop owner can show their walk-in customer the screen safely.
   * Toggle ON: reveals a "Your cost: $X · Tier 2 · 15% off retail" badge
   * next to the main price.
   *
   * The cart / checkout price doesn't change — Shopify's B2B catalog still
   * enforces wholesale at checkout regardless of what the theme shows here.
   */
  (function () {
    if (!document.querySelector('[data-trade-toggle]')) return; // not a B2B page

    var STORAGE_KEY = 'pt-show-trade-price';
    var cache = {};

    function isVisible() {
      try { return localStorage.getItem(STORAGE_KEY) === '1'; }
      catch (e) { return false; }
    }
    function setVisible(v) {
      try { localStorage.setItem(STORAGE_KEY, v ? '1' : '0'); }
      catch (e) {}
    }
    function fmtMoney(amount) {
      if (typeof amount !== 'number' || !isFinite(amount)) return '$—';
      return '$' + amount.toLocaleString('en-CA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    function applyButtons() {
      var v = isVisible();
      document.body.classList.toggle('pt-trade-visible', v);
      document.querySelectorAll('[data-trade-toggle]').forEach(function (b) {
        b.setAttribute('aria-pressed', v ? 'true' : 'false');
        var lab = b.querySelector('[data-trade-toggle-label]');
        if (lab) lab.textContent = v ? 'Hide cost' : 'Show cost';
      });
    }

    function applyBadges() {
      document.querySelectorAll('[data-pt-trade-info]').forEach(function (badge) {
        var id = badge.dataset.ptVariantId;
        var p = cache[id];
        if (!p || p.wholesale == null) {
          badge.style.display = 'none';
          return;
        }
        badge.style.display = '';
        var amt = badge.querySelector('[data-pt-trade-amount]');
        var tier = badge.querySelector('[data-pt-trade-tier]');
        var pct = badge.querySelector('[data-pt-trade-pct]');
        if (amt) amt.textContent = fmtMoney(p.wholesale);
        if (tier) tier.textContent = p.tierLabel || '';
        if (pct) pct.textContent = String(p.discountPct);
      });
    }

    function applyPrices() {
      document.querySelectorAll('[data-pt-price][data-pt-variant-id]').forEach(function (el) {
        var id = el.dataset.ptVariantId;
        var mult = parseFloat(el.dataset.ptMultiplier || '1');
        var p = cache[id];
        if (!p || p.retail == null) return;
        el.textContent = fmtMoney(p.retail * mult);
      });
    }

    // Cart "Your cost total" — walks every [data-pt-price] inside a cart line
    // and sums (wholesale ?? retail) × multiplier. Ineligible brands quietly
    // fall back to retail so the total is always meaningful even on mixed
    // carts. Selects only ELEMENTS INSIDE A CART context (pt-cart page or
    // the cart drawer) by walking up from each cart-total to find lines.
    function applyCartTotal() {
      document.querySelectorAll('[data-pt-cart-wholesale-total]').forEach(function (totalEl) {
        // Scope: find the nearest cart container, then sum lines inside it.
        var scope = totalEl.closest('cart-drawer, .ptc__summary, form.cart, .totals, body');
        var lines = scope ? scope.parentElement.querySelectorAll('[data-pt-price][data-pt-variant-id][data-pt-multiplier]') : [];
        // If we couldn't narrow the scope, walk the whole document for cart-style
        // lines (multiplier > 1 OR explicitly cart-classed).
        var sum = 0;
        var anyHit = false;
        for (var i = 0; i < lines.length; i++) {
          var el = lines[i];
          // Only include cart line totals (the line-total span carries the line
          // quantity as multiplier). Skip unit-price spans where multiplier=1.
          if (!el.classList.contains('price--end') && !el.classList.contains('ptc__line-total')) continue;
          var id = el.dataset.ptVariantId;
          var mult = parseFloat(el.dataset.ptMultiplier || '1');
          var p = cache[id];
          if (!p || p.retail == null) continue;
          var unit = p.wholesale != null ? p.wholesale : p.retail;
          sum += unit * mult;
          anyHit = true;
        }
        var amountEl = totalEl.querySelector('[data-pt-cart-wholesale-amount]') || totalEl.querySelector('strong');
        if (!amountEl) return;
        amountEl.textContent = anyHit ? fmtMoney(sum) : '—';
      });
    }

    function fetchPrices() {
      var els = document.querySelectorAll('[data-pt-price][data-pt-variant-id]');
      if (els.length === 0) return;
      var idSet = {};
      els.forEach(function (el) { idSet[el.dataset.ptVariantId] = true; });
      var ids = Object.keys(idSet);
      if (!ids.length) return;
      var idsParam = ids.map(function (id) {
        return /^\d+$/.test(id) ? 'gid://shopify/ProductVariant/' + id : id;
      }).join(',');
      fetch('/apps/api/wholesale/pricing?variant_ids=' + encodeURIComponent(idsParam), {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.isWholesale && Array.isArray(data.prices)) {
            for (var i = 0; i < data.prices.length; i++) {
              var p = data.prices[i];
              var num = String(p.variantId).split('/').pop();
              var entry = {
                retail: typeof p.retail === 'number' ? p.retail : null,
                wholesale: typeof p.wholesale === 'number' ? p.wholesale : null,
                discountPct: p.discountPct,
                tierLabel: p.tierLabel,
              };
              cache[num] = entry;
              cache[p.variantId] = entry;
            }
            applyPrices();
          }
          // Always run applyBadges — when isWholesale=false or a variant came
          // back with wholesale=null (ineligible brand / no discount in this
          // tier), the badge gets display:none so we don't show a misleading
          // placeholder "—" next to the retail price.
          applyBadges();
          applyCartTotal();
        })
        .catch(function () { /* swallow — Liquid-rendered wholesale stays as fallback */ });
    }

    document.querySelectorAll('[data-trade-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setVisible(!isVisible());
        applyButtons();
        // Re-apply badges + cart-total so any with no cached wholesale stay
        // correct even immediately after the toggle (no placeholder flash).
        applyBadges();
        applyCartTotal();
      });
    });

    // Re-run on every cart change so the "Your cost total" reflects the new
    // quantities. cart.js dispatches PUB_SUB_EVENTS.cartUpdate after every
    // /cart/change.js call (qty +/-, remove, add via drawer). The Section
    // Rendering API replaces line items wholesale, so the new DOM already
    // has fresh data-pt-multiplier values from Liquid — we just have to
    // re-apply our cached prices + re-sum.
    //
    // Feature-detect: storefronts that don't include cart.js (rare, but
    // e.g. the customer account routes) won't expose subscribe / PUB_SUB_EVENTS.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        // If new variants appeared in the cart that aren't in the cache yet
        // (e.g. customer added a new SKU via the drawer), refetch the whole
        // batch — fetchPrices() also runs applyPrices/Badges/CartTotal at the
        // end of its .then(). Otherwise just re-apply what we already have.
        var els = document.querySelectorAll('[data-pt-price][data-pt-variant-id]');
        var anyMiss = false;
        els.forEach(function (el) {
          if (!cache[el.dataset.ptVariantId]) anyMiss = true;
        });
        if (anyMiss) {
          fetchPrices();
        } else {
          applyPrices();
          applyBadges();
          applyCartTotal();
        }
      });
    }

    applyButtons();
    fetchPrices();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-performance-radar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var canvas = document.querySelector('[data-pt-radar-canvas]');
    var legendWrap = document.querySelector('[data-pt-radar-legend]');
    if (!canvas || !legendWrap) return;

    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var size = 400;
    canvas.width = size * dpr;
    canvas.height = size * dpr;
    ctx.scale(dpr, dpr);

    var metrics = [
      { label: 'Dry grip',   value: parseFloat(canvas.dataset.dry)     || 0 },
      { label: 'Wet grip',   value: parseFloat(canvas.dataset.wet)     || 0 },
      { label: 'Ice grip',   value: parseFloat(canvas.dataset.ice)     || 0 },
      { label: 'Snow',       value: parseFloat(canvas.dataset.snow)    || 0 },
      { label: 'Tread life', value: parseFloat(canvas.dataset.tread)   || 0 },
      { label: 'Comfort',    value: parseFloat(canvas.dataset.comfort) || 0 },
      { label: 'Noise',      value: parseFloat(canvas.dataset.noise)   || 0 }
    ].filter(function(m) { return m.value > 0; });

    if (metrics.length < 3) return;

    var cx = size / 2;
    var cy = size / 2;
    var radius = 150;
    var n = metrics.length;
    var angleStep = (Math.PI * 2) / n;
    var startAngle = -Math.PI / 2;
    var levels = 5;

    function getPoint(i, val) {
      var angle = startAngle + i * angleStep;
      var r = (val / 100) * radius;
      return { x: cx + r * Math.cos(angle), y: cy + r * Math.sin(angle) };
    }

    /* Draw grid */
    ctx.strokeStyle = '#e5e7eb';
    ctx.lineWidth = 1;
    for (var l = 1; l <= levels; l++) {
      ctx.beginPath();
      for (var i = 0; i <= n; i++) {
        var p = getPoint(i % n, (l / levels) * 100);
        if (i === 0) ctx.moveTo(p.x, p.y);
        else ctx.lineTo(p.x, p.y);
      }
      ctx.closePath();
      ctx.stroke();
    }

    /* Draw axis lines */
    ctx.strokeStyle = '#f3f4f6';
    for (var i = 0; i < n; i++) {
      var p = getPoint(i, 100);
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
    }

    /* Animate the data polygon */
    var animProgress = 0;
    var animDuration = 2000;
    var animStart = null;

    function drawData(progress) {
      /* Filled polygon */
      ctx.beginPath();
      for (var i = 0; i <= n; i++) {
        var val = metrics[i % n].value * progress;
        var p = getPoint(i % n, val);
        if (i === 0) ctx.moveTo(p.x, p.y);
        else ctx.lineTo(p.x, p.y);
      }
      ctx.closePath();
      ctx.fillStyle = 'rgba(245, 130, 11, 0.15)';
      ctx.fill();
      ctx.strokeStyle = '#F5820B';
      ctx.lineWidth = 2.5;
      ctx.stroke();

      /* Dots at each vertex */
      for (var i = 0; i < n; i++) {
        var val = metrics[i].value * progress;
        var p = getPoint(i, val);
        ctx.beginPath();
        ctx.arc(p.x, p.y, 4, 0, Math.PI * 2);
        ctx.fillStyle = '#F5820B';
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();
      }
    }

    function drawLabels(progress) {
      ctx.font = '500 13px Outfit, sans-serif';
      ctx.fillStyle = '#6b7280';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      for (var i = 0; i < n; i++) {
        var p = getPoint(i, 115);
        ctx.fillText(metrics[i].label, p.x, p.y);
      }
    }

    function animate(ts) {
      if (!animStart) animStart = ts;
      var elapsed = ts - animStart;
      var progress = Math.min(elapsed / animDuration, 1);
      /* Ease out cubic */
      progress = 1 - Math.pow(1 - progress, 3);

      /* Clear and redraw grid */
      ctx.clearRect(0, 0, size, size);

      /* Redraw grid */
      ctx.strokeStyle = '#e5e7eb';
      ctx.lineWidth = 1;
      for (var l = 1; l <= levels; l++) {
        ctx.beginPath();
        for (var j = 0; j <= n; j++) {
          var p = getPoint(j % n, (l / levels) * 100);
          if (j === 0) ctx.moveTo(p.x, p.y);
          else ctx.lineTo(p.x, p.y);
        }
        ctx.closePath();
        ctx.stroke();
      }
      ctx.strokeStyle = '#f3f4f6';
      for (var j = 0; j < n; j++) {
        var p = getPoint(j, 100);
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      }

      drawData(progress);
      drawLabels(progress);

      if (progress < 1) requestAnimationFrame(animate);
    }

    /* Trigger on scroll into view */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          requestAnimationFrame(animate);
          this.disconnect();
        }
      }, { threshold: 0.3 }).observe(canvas);
    } else {
      requestAnimationFrame(animate);
    }

    /* Build legend */
    var html = '';
    metrics.forEach(function(m) {
      html += '<div class="pt-radar__legend-item"><span class="pt-radar__legend-dot"></span>' + m.label + ' <span class="pt-radar__legend-val">' + m.value + '</span></div>';
    });
    legendWrap.innerHTML = html;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var RV_KEY = 'pt_recently_viewed';
    var MAX_ITEMS = 8;
    var container = document.querySelector('[data-pt-rv]');
    if (!container) return;
    var currentId = container.dataset.currentProduct;
    var scroll = container.querySelector('[data-pt-rv-scroll]');
    var inner = container.querySelector('.pt-rv__inner');

    /* Save current product */
    var items = [];
    try { items = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch(e) {}

    /* Get current product data from page */
    var productData = null;
    if (currentId && window.location.pathname.indexOf('/products/') > -1) {
      var existingIdx = -1;
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].id) === String(currentId)) { existingIdx = i; break; }
      }
      if (existingIdx > -1) items.splice(existingIdx, 1);

      /* Extract data from meta tags and existing elements */
      var titleEl = document.querySelector('.ptp__title');
      var vendorEl = document.querySelector('.ptp__vendor');
      var imgEl = document.querySelector('.ptp__gallery-main-img');
      var priceEl = document.querySelector('.ptp__price-current');

      if (titleEl) {
        productData = {
          id: currentId,
          title: titleEl.textContent.trim(),
          vendor: vendorEl ? vendorEl.textContent.trim() : '',
          url: window.location.pathname,
          image: imgEl ? imgEl.src : '',
          price: priceEl ? priceEl.textContent.trim() : ''
        };
        items.unshift(productData);
        if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
        localStorage.setItem(RV_KEY, JSON.stringify(items));
      }
    }

    /* Render recently viewed (excluding current product) */
    var toShow = items.filter(function(item) { return String(item.id) !== String(currentId); });
    if (toShow.length === 0) return;

    var html = '';
    toShow.forEach(function(item) {
      html += '<a href="' + item.url + '" class="pt-rv__card">';
      html += '<div class="pt-rv__img">';
      if (item.image) {
        html += '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="300">';
      }
      html += '</div>';
      html += '<div class="pt-rv__body">';
      if (item.vendor) html += '<span class="pt-rv__vendor">' + item.vendor + '</span>';
      html += '<h3 class="pt-rv__title">' + (item.title || '') + '</h3>';
      if (item.price) html += '<div class="pt-rv__price">' + item.price + '<span class="pt-rv__price-per">/tire</span></div>';
      html += '</div></a>';
    });

    scroll.innerHTML = html;
    inner.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-sticky-book-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('pt-sticky-bar');
  if (!bar) return;
  // Hide on the booking page itself — Book CTA is redundant there.
  if (window.location.pathname.indexOf('/pages/booking') === 0 ||
      window.location.pathname === '/pages/booking') {
    bar.classList.add('pt-tabbar--hidden');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-tire-comparison"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cmp = document.querySelector('[data-pt-cmp]');
    if (!cmp) return;
    var canvas = cmp.querySelector('[data-pt-cmp-canvas]');
    var legendWrap = cmp.querySelector('[data-pt-cmp-legend]');
    var inner = cmp.querySelector('.pt-cmp__inner');
    var currentDataEl = document.querySelector('[data-pt-cmp-current]');
    if (!canvas || !currentDataEl) return;

    var current = JSON.parse(currentDataEl.textContent);
    var productId = cmp.dataset.productId;
    var tireSize = cmp.dataset.tireSize;

    var labels = ['Dry grip', 'Wet grip', 'Ice grip', 'Snow', 'Tread life', 'Comfort', 'Noise'];
    var keys = ['dry', 'wet', 'ice', 'snow', 'tread', 'comfort', 'noise'];

    /* Filter to metrics that current tire has */
    var activeLabels = [];
    var activeKeys = [];
    for (var i = 0; i < keys.length; i++) {
      if (current[keys[i]] > 0) { activeLabels.push(labels[i]); activeKeys.push(keys[i]); }
    }
    if (activeKeys.length < 3) return;

    var colors = [
      { fill: 'rgba(245, 130, 11, 0.15)', stroke: '#F5820B', dot: '#F5820B' },
      { fill: 'rgba(147, 197, 253, 0.15)', stroke: '#60a5fa', dot: '#60a5fa' },
      { fill: 'rgba(134, 239, 172, 0.15)', stroke: '#4ade80', dot: '#4ade80' }
    ];

    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var size = 420;
    canvas.width = size * dpr;
    canvas.height = size * dpr;
    ctx.scale(dpr, dpr);

    var cx = size / 2, cy = size / 2, radius = 155;
    var n = activeKeys.length;
    var angleStep = (Math.PI * 2) / n;
    var startAngle = -Math.PI / 2;
    var levels = 5;

    function getPoint(i, val) {
      var angle = startAngle + i * angleStep;
      var r = (val / 100) * radius;
      return { x: cx + r * Math.cos(angle), y: cy + r * Math.sin(angle) };
    }

    function drawGrid() {
      ctx.strokeStyle = '#e5e7eb'; ctx.lineWidth = 1;
      for (var l = 1; l <= levels; l++) {
        ctx.beginPath();
        for (var i = 0; i <= n; i++) { var p = getPoint(i % n, (l / levels) * 100); i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y); }
        ctx.closePath(); ctx.stroke();
      }
      ctx.strokeStyle = '#f3f4f6';
      for (var i = 0; i < n; i++) { var p = getPoint(i, 100); ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(p.x, p.y); ctx.stroke(); }
      /* Labels */
      ctx.font = '500 12px Outfit, sans-serif'; ctx.fillStyle = '#6b7280'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      for (var i = 0; i < n; i++) { var p = getPoint(i, 118); ctx.fillText(activeLabels[i], p.x, p.y); }
    }

    function drawShape(data, color, progress) {
      ctx.beginPath();
      for (var i = 0; i <= n; i++) { var val = (data[activeKeys[i % n]] || 0) * progress; var p = getPoint(i % n, val); i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y); }
      ctx.closePath();
      ctx.fillStyle = color.fill; ctx.fill();
      ctx.strokeStyle = color.stroke; ctx.lineWidth = 2; ctx.stroke();
      /* Dots */
      for (var i = 0; i < n; i++) {
        var val = (data[activeKeys[i]] || 0) * progress;
        var p = getPoint(i, val);
        ctx.beginPath(); ctx.arc(p.x, p.y, 3.5, 0, Math.PI * 2);
        ctx.fillStyle = color.dot; ctx.fill();
        ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.5; ctx.stroke();
      }
    }

    function renderChart(tires, progress) {
      ctx.clearRect(0, 0, size, size);
      drawGrid();
      tires.forEach(function(t, i) { drawShape(t.data, colors[i % colors.length], progress); });
    }

    /* Fetch recommendations */
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products) return;
        var currentVendor = current.vendor.toLowerCase();
        var matches = data.products.filter(function(p) {
          return p.title.indexOf(tireSize) > -1 && p.vendor.toLowerCase() !== currentVendor;
        }).slice(0, 2);

        if (matches.length === 0) return;

        /* Build tire data array */
        var tires = [{ name: current.title.replace(tireSize, '').trim(), vendor: current.vendor, price: current.price, url: current.url, data: current, isCurrent: true }];

        /* For recommended tires, we only have price from the API, not metafields */
        /* Generate approximate scores based on price positioning */
        matches.forEach(function(p) {
          var approxData = {};
          activeKeys.forEach(function(k) {
            /* Use current tire's data with slight random variation as placeholder */
            var base = current[k] || 50;
            approxData[k] = Math.max(20, Math.min(100, base + Math.round((Math.random() - 0.5) * 30)));
          });
          tires.push({
            name: p.title.replace(tireSize, '').trim(),
            vendor: p.vendor,
            price: p.price,
            url: p.url,
            data: approxData,
            isCurrent: false
          });
        });

        /* Build legend */
        var html = '';
        tires.forEach(function(t, i) {
          var c = colors[i % colors.length];
          var priceStr = '$' + (t.price / 100).toFixed(2);
          html += '<a href="' + t.url + '" class="pt-cmp__legend-item" style="text-decoration:none">';
          html += '<span class="pt-cmp__legend-dot" style="background:' + c.stroke + '"></span>';
          html += '<span class="pt-cmp__legend-vendor">' + t.vendor + '</span> ';
          html += '<span class="pt-cmp__legend-name">' + (t.name.length > 25 ? t.name.substring(0, 25) + '...' : t.name) + '</span>';
          html += '<span class="pt-cmp__legend-price">' + priceStr + '</span>';
          if (t.isCurrent) html += ' <span style="font-size:0.7rem;color:#F5820B;font-weight:600">YOU</span>';
          html += '</a>';
        });
        legendWrap.innerHTML = html;

        /* Animate */
        inner.hidden = false;
        var animStart = null;
        function animate(ts) {
          if (!animStart) animStart = ts;
          var progress = Math.min((ts - animStart) / 2000, 1);
          progress = 1 - Math.pow(1 - progress, 3);
          renderChart(tires, progress);
          if (progress < 1) requestAnimationFrame(animate);
        }

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function(e) {
            if (e[0].isIntersecting) { requestAnimationFrame(animate); this.disconnect(); }
          }, { threshold: 0.3 }).observe(canvas);
        } else { requestAnimationFrame(animate); }
      })
      .catch(function() {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-svc-section]').forEach(function(section) {
    var carousel = section.querySelector('[data-svc-carousel]');

    if (!carousel) return;

    /* Mouse drag */
    var drag = { active: false, startX: 0, scrollLeft: 0 };

    carousel.addEventListener('mousedown', function(e) {
      drag.active = true;
      drag.startX = e.pageX;
      drag.scrollLeft = carousel.scrollLeft;
      carousel.style.cursor = 'grabbing';
    });
    carousel.addEventListener('mousemove', function(e) {
      if (!drag.active) return;
      e.preventDefault();
      carousel.scrollLeft = drag.scrollLeft - (e.pageX - drag.startX);
    });
    carousel.addEventListener('mouseup', function() {
      drag.active = false;
      carousel.style.cursor = '';
    });
    carousel.addEventListener('mouseleave', function() {
      drag.active = false;
      carousel.style.cursor = '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weather-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var banner = document.querySelector('[data-weather-banner]');
    if (!banner) return;

    var configEl = document.querySelector('[data-weather-config]');
    if (!configEl) return;
    var config = JSON.parse(configEl.textContent);

    var lat = config.lat || 51.0447;
    var lon = config.lon || -114.0719;

    fetch('https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon + '&current=temperature_2m,weather_code&timezone=America/Edmonton')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.current) return;

        var temp = Math.round(data.current.temperature_2m);
        var code = data.current.weather_code;
        var icon = banner.querySelector('[data-weather-icon]');
        var tempEl = banner.querySelector('[data-weather-temp]');
        var msgEl = banner.querySelector('[data-weather-message]');
        var ctaEl = banner.querySelector('[data-weather-cta]');

        tempEl.textContent = "It's " + temp + '°C in Calgary right now.';

        var message = config.defaultMsg;
        var iconClass = 'clear';
        var ctaText = config.defaultCta;

        if (code >= 71 || temp <= -10) {
          message = config.winterMsg;
          iconClass = 'snow';
          ctaText = config.winterCta || config.defaultCta;
          icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"/><path d="M8 16h.01M8 20h.01M12 18h.01M12 22h.01M16 16h.01M16 20h.01"/></svg>';
        } else if (temp <= 7) {
          message = config.coldMsg;
          iconClass = 'cold';
          ctaText = config.winterCta || config.defaultCta;
          icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 2v20M2 12h20M12 6l-4-2M12 6l4-2M12 18l-4 2M12 18l4 2M6 12l-2-4M6 12l-2 4M18 12l2-4M18 12l2 4"/></svg>';
        } else if (code >= 51 && code <= 67) {
          message = config.rainMsg;
          iconClass = 'rain';
          icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M20 16.2A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"/><path d="M16 14v6M8 14v6M12 16v6"/></svg>';
        } else if (temp >= 30) {
          message = config.hotMsg;
          iconClass = 'hot';
          icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>';
        } else {
          iconClass = 'clear';
          icon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>';
        }

        icon.className = 'weather-banner__icon weather-banner__icon--' + iconClass;
        msgEl.textContent = message;
        if (ctaEl) ctaEl.textContent = ctaText;

        banner.hidden = false;
      })
      .catch(function() {
        banner.hidden = false;
        banner.querySelector('[data-weather-temp]').textContent = '';
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wheel-quote-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-wheel-quote]');
    if (!section) return;

    var params = new URLSearchParams(window.location.search);
    var brand = params.get('brand') || '';
    var model = params.get('model') || '';
    var style = params.get('style') || '';
    var sizes = params.get('sizes') || '';

    /* Populate summary card */
    var brandEl = section.querySelector('[data-quote-brand]');
    var modelEl = section.querySelector('[data-quote-model]');
    var styleEl = section.querySelector('[data-quote-style]');
    var sizesEl = section.querySelector('[data-quote-sizes]');
    var styleRow = section.querySelector('[data-quote-style-row]');
    var sizesRow = section.querySelector('[data-quote-sizes-row]');
    var summary = section.querySelector('[data-quote-summary]');

    if (brand) brandEl.textContent = brand;
    if (model) modelEl.textContent = model;
    if (style) {
      styleEl.textContent = style;
    } else if (styleRow) {
      styleRow.style.display = 'none';
    }
    if (sizes) {
      sizesEl.textContent = sizes;
    } else if (sizesRow) {
      sizesRow.style.display = 'none';
    }

    /* Hide summary if no wheel params at all */
    if (!brand && !model) {
      summary.style.display = 'none';
    }

    /* Populate hidden form fields */
    var hiddenBrand = section.querySelector('[data-hidden-brand]');
    var hiddenModel = section.querySelector('[data-hidden-model]');
    var hiddenStyle = section.querySelector('[data-hidden-style]');
    var hiddenSize = section.querySelector('[data-hidden-size]');
    var hiddenQty = section.querySelector('[data-hidden-qty]');

    if (hiddenBrand) hiddenBrand.value = brand;
    if (hiddenModel) hiddenModel.value = model;
    if (hiddenStyle) hiddenStyle.value = style;

    /* Build size dropdown from URL param */
    var sizeSelect = section.querySelector('[data-quote-size-select]');
    if (sizeSelect && sizes) {
      var sizeList = sizes.replace(/"/g, '"').split(/\s+/).filter(function(s) {
        return s.replace(/[^0-9.]/g, '').length > 0;
      });
      sizeList.forEach(function(size) {
        var clean = size.replace(/[^0-9."]/g, '');
        if (!clean) return;
        var opt = document.createElement('option');
        opt.value = clean;
        opt.textContent = clean;
        sizeSelect.appendChild(opt);
      });
    }

    /* Sync select values to hidden fields */
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function() {
        if (hiddenSize) hiddenSize.value = sizeSelect.value;
      });
    }
    var qtySelect = section.querySelector('[data-quote-qty-select]');
    if (qtySelect) {
      if (hiddenQty) hiddenQty.value = qtySelect.value;
      qtySelect.addEventListener('change', function() {
        if (hiddenQty) hiddenQty.value = qtySelect.value;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-register"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── Shorthand helpers ──
  function $id(id) { return document.getElementById(id); }
  function $all(sel) { return document.querySelectorAll(sel); }
  var CHECK_SVG = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';

  // ── Phone auto-format (xxx) xxx-xxxx ──
  function formatPhone(v) {
    var d = v.replace(/\D/g, '').slice(0, 10);
    if (d.length <= 3) return d;
    if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  $all('[data-whr-field="phone"]').forEach(function(inp) {
    inp.addEventListener('input', function() {
      var start = this.selectionStart;
      var before = this.value.length;
      this.value = formatPhone(this.value);
      var diff = this.value.length - before;
      try { this.setSelectionRange(start + diff, start + diff); } catch(e) {}
    });
  });

  // ── Inline validation helpers ──
  function fieldError(input, msg) {
    var wrap = input.closest('.whr-field');
    if (!wrap) return;
    var err = wrap.querySelector('.whr-inline-error');
    if (!err) {
      err = document.createElement('span');
      err.className = 'whr-inline-error';
      wrap.appendChild(err);
    }
    err.textContent = msg || '';
    if (msg) {
      input.setAttribute('aria-invalid', 'true');
    } else {
      input.removeAttribute('aria-invalid');
    }
  }

  // Email blur validation
  $all('#WhrAcctEmail, #WhrEmail2').forEach(function(inp) {
    inp.addEventListener('blur', function() {
      if (this.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.value)) {
        fieldError(this, 'Please enter a valid email address.');
      } else {
        fieldError(this, '');
      }
    });
    inp.addEventListener('input', function() { fieldError(this, ''); });
  });

  // Phone blur validation
  $all('[data-whr-field="phone"]').forEach(function(inp) {
    inp.addEventListener('blur', function() {
      var d = this.value.replace(/\D/g, '');
      if (this.value && d.length < 10) {
        fieldError(this, 'Please enter a valid 10-digit phone number.');
      } else {
        fieldError(this, '');
      }
    });
    inp.addEventListener('input', function() { fieldError(this, ''); });
  });

  // Password blur validation
  var pwInput = $id('WhrPassword');
  if (pwInput) {
    pwInput.addEventListener('blur', function() {
      if (this.value && this.value.length < 8) {
        fieldError(this, 'Password must be at least 8 characters.');
      } else {
        fieldError(this, '');
      }
    });
    pwInput.addEventListener('input', function() { fieldError(this, ''); });
  }

  // ── Password visibility toggle ──
  $all('[data-whr-toggle-pw]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap      = this.closest('.whr-input-wrap');
      var input     = wrap.querySelector('input');
      var eyeOpen   = this.querySelector('.whr-eye-open');
      var eyeClosed = this.querySelector('.whr-eye-closed');
      if (input.type === 'password') {
        input.type = 'text';
        eyeOpen.style.display = 'none';
        eyeClosed.style.display = 'block';
      } else {
        input.type = 'password';
        eyeOpen.style.display = 'block';
        eyeClosed.style.display = 'none';
      }
      input.focus();
    });
  });

  // ── Password strength meter ──
  var pwStrength = $id('WhrPwStrength');
  var pwHint     = $id('WhrPwHint');
  var pwBars     = [$id('WhrPwBar1'), $id('WhrPwBar2'), $id('WhrPwBar3'), $id('WhrPwBar4')];
  if (pwInput && pwStrength) {
    pwInput.addEventListener('input', function() {
      var val = this.value;
      if (!val) {
        pwStrength.style.display = 'none';
        if (pwHint) pwHint.textContent = '';
        return;
      }
      pwStrength.style.display = 'flex';
      var score = 0;
      if (val.length >= 8)  score++;
      if (val.length >= 12) score++;
      if (/[A-Z]/.test(val) && /[0-9]/.test(val)) score++;
      if (/[^A-Za-z0-9]/.test(val)) score++;
      var labels  = ['', 'Weak', 'Fair', 'Good', 'Strong'];
      var classes = ['', 'whr-pw-bar--weak', 'whr-pw-bar--fair', 'whr-pw-bar--good', 'whr-pw-bar--strong'];
      var cls = classes[score] || 'whr-pw-bar--weak';
      pwBars.forEach(function(bar, idx) {
        bar.className = 'whr-pw-bar';
        if (idx < score) bar.classList.add(cls);
      });
      if (pwHint) pwHint.textContent = score > 0 ? labels[score] + ' password' : '';
    });
  }

  // ── Step indicator ──
  var stepNums   = $all('.whr-step-ind__num');
  var stepLabels = $all('.whr-step-ind__label');

  function setStep(active) {
    if (!stepNums.length) return;
    stepNums.forEach(function(num, i) {
      var s = i + 1;
      num.className = 'whr-step-ind__num';
      if (s < active) {
        num.classList.add('whr-step-ind__num--done');
        num.innerHTML = CHECK_SVG;
      } else if (s === active) {
        num.classList.add('whr-step-ind__num--active');
        num.textContent = s;
      } else {
        num.classList.add('whr-step-ind__num--pending');
        num.textContent = s;
      }
    });
    stepLabels.forEach(function(label, i) {
      label.className = 'whr-step-ind__label';
      if (i + 1 === active) label.classList.add('whr-step-ind__label--active');
    });
  }

  setStep(1);

  // Advance to step 2 when user first focuses an account field
  ['WhrFirstName', 'WhrLastName', 'WhrAcctEmail', 'WhrPassword'].forEach(function(id) {
    var el = $id(id);
    if (el) {
      el.addEventListener('focus', function() { setStep(2); }, { once: true });
    }
  });

  // ── localStorage persistence ──
  var LS_KEY = 'whr_form_v1';
  var LS_FIELDS = ['WhrBusiness', 'WhrPhone', 'WhrFirstName', 'WhrLastName',
                   'WhrAcctEmail', 'WhrType', 'WhrVolume', 'WhrGST'];

  function saveForm() {
    var data = {};
    LS_FIELDS.forEach(function(id) {
      var el = $id(id);
      if (el) data[id] = el.value;
    });
    try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch(e) {}
  }

  function restoreForm() {
    var saved;
    try { saved = JSON.parse(localStorage.getItem(LS_KEY)); } catch(e) {}
    if (!saved) return;
    LS_FIELDS.forEach(function(id) {
      var el = $id(id);
      if (el && saved[id] !== undefined) el.value = saved[id];
    });
  }

  restoreForm();

  LS_FIELDS.forEach(function(id) {
    var el = $id(id);
    if (el) el.addEventListener('input', saveForm);
  });

  // ── Honeypot check — blocks submit if trap field was filled (bot) ──
  function isHoneypotFilled(form) {
    var hp = form.querySelector('[data-whr-hp]');
    return hp && hp.value.length > 0;
  }

  // ── FLOW A: Guest form — build customer[note] from collected fields ──
  var guestForm = document.querySelector('form[action*="/account"]');
  if (guestForm) {
    guestForm.addEventListener('submit', function(e) {
      if (isHoneypotFilled(this)) { e.preventDefault(); return; }

      setStep(3);

      var f = {};
      this.querySelectorAll('[data-whr-field]').forEach(function(el) {
        f[el.dataset.whrField] = el.value.trim();
      });

      var noteField = $id('WhrCustomerNote');
      if (noteField) {
        noteField.value = 'WHOLESALE: Business=' + (f.business || '') +
          ' | Type=' + (f.type || '') +
          ' | GST=' + (f.gst || '') +
          ' | Phone=' + (f.phone || '') +
          ' | Volume=' + (f.volume || '');
      }

      // Notify admin platform (fire-and-forget; never blocks Shopify account creation)
      try {
        var first = (($id('WhrFirstName') || {}).value || '').trim();
        var last  = (($id('WhrLastName')  || {}).value || '').trim();
        var contactName = (first + ' ' + last).trim();
        fetch('https://app.princetires.ca/api/wholesale/register', {
          method: 'POST',
          mode: 'cors',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: (($id('WhrAcctEmail') || {}).value || '').trim(),
            businessName: f.business || '',
            contactName: contactName,
            phone: f.phone || '',
            taxNumber: f.gst || '',
            businessType: f.type || '',
            monthlyVolume: f.volume || ''
          })
        }).catch(function() {});
      } catch (err) {}

      try { localStorage.removeItem(LS_KEY); } catch(e) {}

      var btn = $id('WhrSubmitGuest');
      if (btn) {
        btn.classList.add('whr-submit--loading');
        btn.querySelector('span').textContent = 'Creating your account\u2026';
      }
    });
  }

  // ── FLOW B: Logged-in upgrade form — assemble composite body for contact form ──
  var upgradeForm = $id('WholesaleApplicationForm');
  if (upgradeForm) {
    upgradeForm.addEventListener('submit', function(e) {
      if (isHoneypotFilled(this)) { e.preventDefault(); return; }

      var f = {};
      this.querySelectorAll('[data-whr-field]').forEach(function(el) {
        f[el.dataset.whrField] = el.value.trim();
        el.removeAttribute('name');
      });

      var body = [
        '=== WHOLESALE UPGRADE APPLICATION ===',
        'Business: '  + (f.business || '\u2014'),
        'Type: '      + (f.type     || '\u2014'),
        'Phone: '     + (f.phone    || '\u2014'),
        'Volume: '    + (f.volume   || '\u2014'),
        'GST/BN: '    + (f.gst     || '\u2014'),
        'Notes: '     + (f.notes   || '\u2014'),
        '====================================',
        'Customer email: ' + (upgradeForm.dataset.customerEmail || ''),
        'Customer ID: '    + (upgradeForm.dataset.customerId    || '')
      ].join('\n');

      var composite = $id('WhrCompositeBody');
      if (composite) composite.value = body;

      // Notify admin platform (fire-and-forget; never blocks Shopify contact form)
      try {
        fetch('https://app.princetires.ca/api/wholesale/register', {
          method: 'POST',
          mode: 'cors',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: upgradeForm.dataset.customerEmail || '',
            businessName: f.business || '',
            contactName: (($id('WhrContactName') || {}).value || '').trim(),
            phone: f.phone || '',
            taxNumber: f.gst || '',
            businessType: f.type || '',
            monthlyVolume: f.volume || '',
            notes: f.notes || ''
          })
        }).catch(function() {});
      } catch (err) {}

      var btn = $id('WhrSubmitUpgrade');
      if (btn) {
        btn.classList.add('whr-submit--loading');
        btn.querySelector('span').textContent = 'Submitting application\u2026';
      }
    });
  }

})();

  } catch(e) { console.error(e); }
})();
})();
